import SettingsDataQualityContainer from './containers/SettingsDataQualityContainer';

export default SettingsDataQualityContainer;

